import { useRef, useState } from "react";
import { notification, PessoaService } from "../../../../services";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import {
  Autocomplete,
  Button,
  DataGrid,
  FormControl,
  TextField,
  Grid,
} from "../../../../components";

const TabelaVendaClientes = ({
  tabelaClientes,
  resetForm,
  loading,
  setLoading,
  tabelaVendaEntity,
  setTabelaVenda,
}) => {
  const inputRef = useRef();
  const pessoasService = new PessoaService();
  const [pessoasList, setPessoasList] = useState([]);
  const [pessoaSelecionada, setPessoaSelecionada] = useState(null);
  const [tabelaVendaPessoas, setTabelaVendaPessoas] = useState(
    tabelaClientes?.length ? tabelaClientes : []
  );
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
      filtrar: true,
    },
    {
      field: "nomeRazaoSocial",
      headerName: "Nome / Razão Social",
      flex: 700,
      filtrar: true,
    },
  ];

  async function buscarPessoas(filtros) {
    setLoading(true);
    try {
      const filtrosComuns = {
        ...filtros,
        orderBy: "codigo",
        order: "asc",
        tiposPessoaId: 1,
        ativado: true,
        limite: 20,
      };
      const res = await pessoasService.getAll(filtrosComuns);
      if (!res.isAxiosError) {
        setPessoasList(res.data.rows);
      } else {
        responseErros(res);
      }
    } catch (error) {
      console.error("Erro ao buscar pessoas:", error);
      notification.error("Erro ao buscar pessoas.");
    } finally {
      setLoading(false);
    }
  }

  const handleChangePessoaSelecionada = (e, value) => {
    if (value) {
      setPessoaSelecionada(value);
      document.getElementById("buttonAdicionarPessoa").focus();
    } else {
      resetForm();
    }
  };

  const handleAdicionarPessoa = () => {
    if (!pessoaSelecionada) {
      return notification.alertaGenericos(
        "Selecione uma pessoa para adicionar"
      );
    }
    const pessoaInserida = tabelaVendaPessoas.find(
      (item) => item.id == pessoaSelecionada.id
    );
    if (pessoaInserida) {
      notification.alertaGenericos("Pessoa já inserida.");
    } else {
      const tabelaVendaPessoasTemp = [...tabelaVendaPessoas, pessoaSelecionada];
      tabelaVendaEntity.setHandleChangeAutoCompleteMultiSelecting(
        "pessoaIds",
        tabelaVendaPessoasTemp
      );
      setTabelaVenda({ ...tabelaVendaEntity });
      setTabelaVendaPessoas(tabelaVendaPessoasTemp);
    }
    setPessoaSelecionada(null);
    document.getElementById("pessoaId").focus();
  };

  const handleRemoverPessoa = async (id) => {
    const data = tabelaVendaPessoas.filter((item) => item.id !== id);
    const pessoaSelecionada = tabelaVendaPessoas.find(
      (item) => item.id === id
    ).nomeRazaoSocial;
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${pessoaSelecionada} da lista?`
    );
    if (retornoAlerta.isConfirmed) {
      tabelaVendaEntity.setHandleChangeAutoCompleteMultiSelecting(
        "pessoaIds",
        data
      );
      setTabelaVenda({ ...tabelaVendaEntity });
      setTabelaVendaPessoas(data);
    }
    resetForm();
  };

  const onInputChangePessoas = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setPessoasList([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      event.preventDefault();
      const filtros = {
        nomeRazaoSocial: eventValue,
      };
      setLoadingAutoComplete(true);
      timeoutBuscaAutocomplete(buscarPessoas(filtros));
    }
  };

  return (
    <>
      <form>
        <Grid container spacing={2} alignItems="center" mb={2} columns={14}>
          <Grid item xs={4}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="pessoaId"
                name="pessoaId"
                options={pessoasList}
                autoHighlight
                loading={loadingAutoComplete}
                loadingText="Carregando"
                noOptionsText="Digite e pressione Enter"
                getOptionLabel={(option) =>
                  option.nomeRazaoSocial ? `${option.nomeRazaoSocial}` : ""
                }
                filterSelectedOptions
                onChange={handleChangePessoaSelecionada}
                value={pessoaSelecionada}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant={"outlined"}
                    label="Buscar Pessoa"
                    onKeyDown={(e) => onInputChangePessoas(e)}
                    inputRef={inputRef}
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={1} sx={{ mt: 1 }}>
            <Button
              id="buttonAdicionarPessoa"
              variant="contained"
              color="success"
              size="small"
              sx={{
                height: "35px",
                borderRadius: "20%",
                minWidth: "10px",
                boxShadow: "none",
              }}
              onClick={handleAdicionarPessoa}
            >
              <i
                className="ph-bold ph-plus"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </Grid>
        </Grid>
      </form>
      <DataGrid
        rows={tabelaVendaPessoas}
        columns={colunas}
        rowCount={tabelaVendaPessoas.length}
        loading={loading}
        noFilter
        deleteShow
        editShow={false}
        onClickDelete={handleRemoverPessoa}
      />
    </>
  );
};

export default TabelaVendaClientes;
